// extracted by css-extract-rspack-plugin
export default {"ActionButton":"AddSeriesButton-module__ActionButton___uQ9XQ"};